import { IArticlePropertyModel } from 'gen/ApiClient';
import { IArticlePropertyLine } from '../IArticlePropertyLine';

export const articlePropertyLineToModel = (line: IArticlePropertyLine): IArticlePropertyModel => {
	return {
		key: line.apk.key,
		values: line.values,
	};
};
